export enum SchoolStudentStatus{
    Active,
    Inactive
}